import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Input, Label } from "reactstrap"

function Checkbox(props) {
  const {inputProps: {data, defaultValues, itemName, itemType, handler, index}} = props;
  const handleChange = e => {
    const answers = []
    const grandParent = e.target.parentNode.parentNode
    const checkBoxes = grandParent.querySelectorAll(`[name="${e.target.name}"]`)
    checkBoxes.forEach(checkBox => {
      if (checkBox.checked) {
        answers.push({
          sequence: +checkBox.value,
          answer: checkBox.dataset.answer,
        })
      }
    })

    const answer = {
      formId: data.formId,
      sequence: data.sequence,
      answers: answers,
    }
    return handler({
      answer,
      type: itemType,
      itemName,
      index,
    })
  }
  return (
    <div className="d-flex justify-content-start gap-2">
      {data.answers.map(ans => {
        let isChecked = false
        if (defaultValues) {
          const _defaultValue = defaultValues.find(
            val => val.formId === data.formId
          )
          if (_defaultValue) {
            isChecked =
              _defaultValue?.answers?.find(an => an.answer === ans.label) !==
              undefined
          }
        }
        return (
          <div className="d-flex" key={ans.sequence}>
            <Input
              type="checkbox"
              className="me-2"
              defaultChecked={isChecked}
              id={`chb${data.formId}${data.sequence}${ans.sequence}`}
              name={`chb${data.formId}${data.sequence}`}
              onChange={handleChange}
              data-answer={ans.label}
              value={ans.sequence}
            />
            <Label htmlFor={`chb${data.formId}${data.sequence}${ans.sequence}`}>
              {ans.label}
            </Label>
          </div>
        )
      })}
    </div>
  )
}

function TextInput(props) {
  const {inputProps: {data, defaultValues, itemName, itemType, handler, index}} = props;
  const handleChange = e => {
    const answer = {
      formId: data.formId,
      sequence: data.sequence,
      answers: [
        {
          sequence: 1,
          answer: e.target.value,
        },
      ],
    }
    return handler({
      answer,
      itemName,
      type: itemType,
      index,
    })
  }
  let defaultValue = ""
  if (defaultValues) {
    const _defaultValue = defaultValues.find(val => val.formId === data.formId)
    defaultValue = _defaultValue?.answers[0]?.answer
  }
  return (
    <div style={{ width: "100%" }}>
      <Input
        className="me-2"
        type="text"
        data-sequence={1}
        defaultValue={defaultValue}
        onChange={handleChange}
      />
    </div>
  )
}

function DropdownSelect(props) {
  const {inputProps: {data, defaultValues, itemName, itemType, handler, index}} = props;
  const handleChange = (e) => {
    const answer = {
      formId: data.formId,
      sequence: data.sequence,
      answers: [
        {
          sequence: e.value,
          answer: e.label
        }
      ],
    }
    return handler({
      answer,
      itemName,
      type: itemType,
      index,
    })
  }
  const defaultValue = { label: "", value: "" }
  if (defaultValues) {
    const _defaultValue = defaultValues.find(val => val.formId === data.formId)
    if (_defaultValue) {
      defaultValue.label = _defaultValue?.answers[0]?.answer
      defaultValue.value = _defaultValue?.answers[0]?.sequence
    }
  }
  return (
    <div style={{ width: "100%" }}>
      <SelectBox
        options={data.answers.map(a => ({
          label: a.label,
          value: a.sequence,
        }))}
        onChange={handleChange}
        value={defaultValue}
      />
    </div>
  )
}

function RadioInput(props) {
  const {inputProps: {data, defaultValues, itemName, itemType, handler, index}} = props;
  const handleChange = (e) => {
    const answer = {
      formId: data.formId,
      sequence: data.sequence,
      answers: [
        {
          sequence: +e.target.value,
          answer: e.target.dataset.label,
        }
      ]
    }
    return handler ({
      answer,
      itemName,
      type: itemType,
      index
    })
  }
  return (
    <div className="d-flex justify-content-start gap-2">
      {data.answers.map(answer => {
        let isChecked = false

        if (defaultValues) {
          const defaultValue = defaultValues.find(
            val => val.formId === data.formId
          )
          if (defaultValue?.answers[0]?.answer === answer.label)
            isChecked = true
        }

        return (
          <div className="d-flex" key={answer.sequence}>
            <Input
              type="radio"
              className="me-2"
              id={`rad${data.formId}${data.sequence}${answer.sequence}`}
              defaultChecked={isChecked}
              name={`rad${data.formId}${data.sequence}`}
              value={answer.sequence}
              data-label={answer.label}
              onChange={handleChange}
            />
            <Label
              htmlFor={`rad${data.formId}${data.sequence}${answer.sequence}`}
            >
              {answer.label}
            </Label>
          </div>
        )
      })}
    </div>
  )
}

export { RadioInput, DropdownSelect, TextInput, Checkbox }
